import { InAppMessagePresentationContext } from "./presentation/InAppMessagePresentationContext"

export type PresentResponseCode = "PRESENT" | "ALREADY_PRESENTED" | "IN_PROGRESS" | "EXCEPTION"

export class InAppMessagePresentResponse {
  constructor(public readonly code: PresentResponseCode, public readonly context: InAppMessagePresentationContext) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentResponse(code=${this.code}, dispatchId=${this.context.dispatchId}, inAppMessage=${this.context.inAppMessage}, displayType=${this.context.message.layout.displayType}, layoutType=${this.context.message.layout.layoutType})`
  }

  static of(code: PresentResponseCode, context: InAppMessagePresentationContext): InAppMessagePresentResponse {
    return new InAppMessagePresentResponse(code, context)
  }
}
